import React from "react";
import "./Licensiering.css";
import Licensieringimg from "../../assets/ttgimage4.jpg";

const Licensiering = () => {
  return (
    <div className="box-2-taktillgolv-main-info-TeamMeeting-1">
      <div className="taktillgolv-text-container-3-custom-TeamMeeting-1">
        <div className="taktillgolv-title-3-custom-TeamMeeting">
          Expertis och Licensiering för Smidiga Byggprojekt
        </div>

        <div className="taktillgolv-text-3-custom1-TeamMeeting">
          Vi på Tak Till Golv strävar inte bara efter att leverera
          högkvalitativa byggtjänster, utan vi erbjuder även den nödvändiga
          expertisen och licensieringen för att göra hela processen så smidig
          som möjligt för våra kunder. Med vår djupa förståelse för
          byggbranschens regler och föreskrifter kan vi hjälpa er att navigera
          genom den komplicerade processen att ansöka om tillstånd och bygglov.
          <br></br>
          <br></br>
          Vi är specialiserade på att hantera tillstånd och godkännanden för
          alla typer av byggprojekt, från små renoveringar till stora
          nybyggnationer. Vårt erfarna team av yrkesmän och samarbetspartners
          har den kompetens och kunskap som krävs för att säkerställa att ert
          projekt uppfyller alla lokala regler och krav. Låt oss ta hand om det
          administrativa arbetet så att ni kan fokusera på att förverkliga era
          byggdrömmar.
          <br></br>
          <br></br>
          Med Tak Till Golv vid er sida kan ni lita på att ert projekt kommer
          att genomföras smidigt och effektivt, med alla nödvändiga tillstånd
          och godkännanden på plats. Vi tar hand om allt det juridiska och
          administrativa arbetet så att ni kan känna er trygga i att ert
          byggprojekt är i goda händer.
        </div>
      </div>
      <div className="taktillgolv-image-container-right-1-3-custom-TeamMeeting-1">
        <img src={Licensieringimg} alt="Square Image" />
      </div>
    </div>
  );
};

export default Licensiering;
